import Typography from "@components_v2/typography/typography";
import { IconChevronRight } from "@mzc-cloudplex/icons";
import { Box, Button, Grid, Stack } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import { useHistory } from "react-router-dom";

const BreadcrumbV2 = ({ breadcrumb, currentItem, actions }) => {
    const history = useHistory();

    return (
        <Stack direction={"row"} sx={{ justifyContent: "space-between", gap: theme.spacing(1) }}>
            <Stack
                direction={"row"}
                sx={{ alignItems: "center", minWidth: "fit-content", flexShrink: 0 }}
                height={32}
                mb={2}
                mt={1}
            >
                {breadcrumb?.map((item, index) => (
                    <>
                        <Grid item key={item.id}>
                            {item.path ? (
                                <Button rounded size="small" variant="basic" onClick={(e) => history.push(item.path)}>
                                    <Typography variant="h3" color={theme.palette.greySecondary.main}>
                                        {item.name}
                                    </Typography>
                                </Button>
                            ) : (
                                <Typography
                                    variant="h3"
                                    color={theme.palette.greySecondary.main}
                                    sx={{ mr: theme.spacing(2) }}
                                >
                                    {item.name}
                                </Typography>
                            )}
                        </Grid>
                        {index < breadcrumb.length - 1 && (
                            <Grid item sx={{ mr: theme.spacing(2) }}>
                                <IconChevronRight size={16} htmlColor={theme.palette.greySecondary[600]} />
                            </Grid>
                        )}
                    </>
                ))}
                <Grid item>
                    {currentItem && (
                        <Stack direction={"row"} gap={theme.spacing(1.5)}>
                            {breadcrumb.length > 0 && ( //Note: custom menus를 아직 불러오지 못해 breadcrumb이 없는 경우(ex: LNB 없는 에셋 상세) 아이콘을 표시하면 안 됨
                                <Box>
                                    <IconChevronRight size={16} htmlColor={theme.palette.greySecondary[600]} />
                                </Box>
                            )}
                            {currentItem.icon && currentItem.icon}
                            <Box>
                                <Typography variant="h3" color={theme.palette.greySecondary.main}>
                                    {currentItem.name}
                                </Typography>
                            </Box>
                        </Stack>
                    )}
                </Grid>
            </Stack>
            <Stack direction={"row"} sx={{ alignItems: "center", minWidth: "fit-content", flexShrink: 0 }}>
                {actions}
            </Stack>
        </Stack>
    );
};

export default BreadcrumbV2;
